// extracted by mini-css-extract-plugin
module.exports = {"inputArea":"list_inputArea__1VcM5","inputBtns":"list_inputBtns__3wrUg"};